<template>
  <div id="container">
    <div class="full_layout">{{rulesTitle}}</div>
  </div>
</template>


<script>
//从app.vue 往 Child.vue中传递信息。
import bus from '@/api/bus';
export default {
  name: 'index',
  data () {
    return {
      loading:false,
      list:'',
      aside:2,
      rulesTitle:'123',
      title:this.$t('title.rulesAPolicies')
    }
  },
  mounted() {
  },
  created(){
    console.log(this.$route.params.id,'this.$route')
    this.rulesTitle=this.$route.params.id
    bus.$emit('headerTitle',this.title);
  },
  methods: {
  } 
} 
</script>

<style scoped>
@import "../../../static/css/terms.css";

</style>



// WEBPACK FOOTER //
// src/pages/terms/tag.vue